import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-adapter-date-fns";
import Compliances_Remainder from "../../Components/Compliances_Remainders/Compliances_Remainder";
import DashboardHeader from "../../Components/DashboardComponent/DashboardHearder/DashboardHeader";
import Todo from "../../Components/ToDo/Todo";
import "./Dashboard.scss";
import LiveData from "./LiveData";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);
//todo we need to the individuval componenets
const Dashboard = () => {
  let company = JSON.parse(sessionStorage.getItem("CompanyCode") || "{}");
  return (
    <div className="DashboardContainer">
      {company?.CompanyCode === "C663191" && (
        <>
          <h2 className="Dashboard-Title">Dashboard </h2>
          <DashboardHeader />

          <LiveData />
        </>
      )}

      <div className="DashboardBelowLiveData">
        <div className="DashboardLeft">
          <Todo />
        </div>
        <div className="DashboardRight">
          <Compliances_Remainder />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
